import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createUploadDocumentsThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.UploadDocuments,
    async ({ applicationId, files }: { applicationId: string; files: File[] }) => {
      await api.uploadDocuments(applicationId, { files });
    },
  );
